import { selectByMode } from "./mode";

// Base URL of the public site (Astro / lesateliersoo.fr), per environment.
const config = {
  localhost: { url: "http://localhost:4321" },
  dev: { url: "https://lesateliersoo.fr" },
  production: { url: "https://lesateliersoo.fr" },
  test: { url: "test.com" },
  demo: { url: "http://localhost:4321" },
};

export default selectByMode(config);
